import { useTranslation } from "react-i18next";

/**
 * Form schemas carry `common:validation.*` keys as their plain-string messages,
 * so a schema stays a module-level constant and its `z.infer` type export is
 * unaffected. The key is resolved here, at the render boundary. A message that
 * is not a key — a server message, a library default — renders as its own text.
 */
export const useValidationMessage = () => {
  const { t } = useTranslation("common");

  return (message?: string): string | undefined =>
    message === undefined ? undefined : t(message, { defaultValue: message });
};
